module.exports = __webpack_public_path__ + "img/aghk-car-default.39e24054.svg";